var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-btn',{attrs:{"icon":""},on:{"click":function($event){return _vm.changeMute('not')}}},[(_vm.mute)?_c('v-icon',[_vm._v("volume_mute")]):_c('v-icon',[_vm._v("volume_up")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }